import { QueryHookOptions, useQuery } from "@apollo/client";

import {
  GuestCartQuery,
  GuestCartQueryVariables,
} from "@whoppah/apollo/schema";

import guestCartQuery from "../query/guestCart.graphql";

const useGuestCart = (
  options?: QueryHookOptions<GuestCartQuery, GuestCartQueryVariables>
) => {
  return useQuery(guestCartQuery, options);
};

export default useGuestCart;
